
interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-8 py-5">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/c2c58b8e-fe26-41d7-95e5-fc329b10f567.png" 
              alt="BRANKOR DOO Logo" 
              className="h-10 w-10 object-contain"
            />
            <h1 className={`text-xl font-semibold transition-colors ${
              scrolled ? 'text-slate-900' : 'text-white'
            }`}>
              BRANKOR DOO
            </h1>
          </div>
          
          <div className="flex items-center gap-12">
            {['home', 'about', 'products', 'features', 'contact'].map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item)}
                className={`text-sm uppercase tracking-wide transition-colors cursor-pointer whitespace-nowrap ${
                  scrolled 
                    ? 'text-slate-600 hover:text-cyan-500' 
                    : 'text-slate-200 hover:text-cyan-400'
                }`}
              >
                {item}
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}
